import axios from "axios";
import { GetUrlParam } from "../utils/common";
import request from "../utils/request";
const preFix = '/cloud/api'

// 上传文件
export function uploadFile(options = { token: "", file: "", key: "" }) {
  const formData = new FormData();
  formData.append("token", options.token);
  formData.append("file", options.file);
  formData.append("key", options.key);
  return axios({
    // url: QINIU_URL,
    headers: {
      "Content-type": "multipart/form-data",
    },
    data: formData,
    method: "POST",
  });
}

// 获取七牛云token
export function fetchQiniuToken() {
  return request("/common/qiniu/token", {
    method: "POST",
  });
}

// 获取用户优惠券
export function getTicketById(params){
  let url = `${preFix}/product/coupon/list?exclusiveId=${params.exclusiveId}&productId=${params.productId}`
  if(params.password){
    url+=`&password=${params.password}`
  }
  return request(url, {
    method: "GET",
    data: params
  });
}

// 获取用户优惠券zfb
export function getTicketById2(params){
  let url = `${preFix}/product/coupon/list/v2?productId=${params.productId || ''}`
  if(params.mobile){
    url+=`&mobile=${params.mobile}`
  }
  if(params.exclusiveId){
    url+=`&exclusiveId=${params.exclusiveId}`
  }
  return request(url, {
    method: "GET",
    data: params
  });
}

// 微信获取用户优惠券
export function getCoupons(params){
  return request(`${preFix}/account/coupon/list?productId=${params.productId}`, {
    method: "GET",
    data: params
  });
}

/**
 * 获取分享的凭证
 * @param {分享的url} data 
 */
 export function getShareTicket(data){
  return request(`${preFix}/course/live/share`, {
    method: "POST",
    data
  });
}

/**
 * 分享图片 课程type 0 套餐type 1 
 */
export function getShareImg(id,type){
  let nid = id? id ==='1'? GetUrlParam('activityId') : GetUrlParam('id') : GetUrlParam('activityId') ; 
  let ntype = 0
  if(type){
    ntype = id? id ==='1'? 2 : 1 : 2
  }
  return request(`${preFix}/course/live/${nid || 1}/sharePic?type=${ntype}`, {
    method: 'GET'
  })
}


/**
 * 记录推荐人
 */
export function referrer(id){
  return request(`${preFix}/account/${id}/referrer`, {
    method: 'GET'
  })
}

/**
 * 上报错误日志
 */
export function errorUpload(data){
  return request(`${preFix}/account/errorReport`, {
    method: 'post',
    data
  })
}

/**
 * 获取服务器时间
 */
export function getServeTime(){
  return request(`${preFix}/sys/time`, {
    method: 'GET'
  })
}

/**
 * 获取分享的知识套餐的详情
 */
export function getProductInfo(id){
  return request(`${preFix}/user/order/product/${id}/check`,{
    method: 'GET'
  })
}

/**
 * 获取系统环境信息
 */
export function getEnvValue(){
  return request(`${preFix}/sys/envValue`,{
    method: 'GET'
  })
}
/*
* 通过课程编号查看订单编号
*/
export function getOrderNo(data) {
  return request(`${preFix}/order/unActive/orderNo`,{
    method: 'GET',
    params:data
  })
}
// 判断选择的优惠券是否互斥
export function checkCouponIds(productId,data){
  return request(`${preFix}/product/${productId}/check`, {
    method: "GET",
    params:data
  });
}
// 查询会员等级数据列表
export function getLabelList(){
  return request(`${preFix}/member/label/list`,{
    method:'GET',
    params:{
      pageIndex:1,
      pageSize:999
    }
  })
}